import API from 'utils/API'
import config from 'app/config'

export const webSocialMediaList = params => (
  () => new Promise((resolve, reject) => (
    API.get(
      `/web/social-media${params || ''}`,
      { headers: { Authorization: `Bearer ${config.api_key}` } },
    ).then(
      (response) => {
        const { data, message } = response?.data
        if (message === 'OK') {
          resolve(data)
        } else {
          reject(data)
        }
      },
    ).catch((err) => {
      reject(err.message) // eslint-disable-line no-console
    })
  ))
)
